import request from '@/utils/request';
// 获取资源配置
export function systemConfigResourse(data) {
  return request.post('admin/system-config/resourse', data);
}
// 获取条款文件列表
export function systemConfigFileList(data) {
  return request.post('admin/system-config/fileList', data);
}
// 新增配置
export function systemConfigStore(data) {
  return request.post('admin/system-config/store', data);
}
// 校验文件名称重复
export function systemConfigCheckFilename(data) {
  return request.post('admin/system-config/checkFilename', data);
}
// 编辑配置
export function systemConfigEdit(data) {
  return request.post('admin/system-config/edit', data);
}
// 文章详情
export function systemConfigDetail(data) {
  return request.post('admin/system-config/detail', data);
}